import ScafomRux from "./Scafomrux";

export default ScafomRux;
